<template>
  <div
    data-aos="fade-up"
    data-aos-delay="20"
    data-aos-duration="500"
  >
    <v-card class="elevation-2 dynamic-width-timeline-card">
      <v-row no-gutters class="pa-4">
        <v-col cols="12" md="3" class="d-flex justify-center" align="center">
          <div class="my-3">
            <v-img height="50" width="50" contain :src="image"></v-img>
          </div>
        </v-col>
        <v-col cols="12" md="9">
          <div class="py-2">
            <p style="font-size:20px;font-weight:500" class="mb-0 px-2 text-left">{{ company }}</p>
            <p class="mb-0 px-2 text-left">{{ position }}</p>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "TimelineCardHome",
  data: () => ({
    themeColor: "#1F6C8C"
  }),
  props: {
    image: String,
    company: String,
    position: String
  },
  methods: {
    deleteTimeline() {
      this.$emit("deleteTimeline");
    }
  }
};
</script>

<style>
@import "../../assets/css/colors.css";
@import "../../assets/css/vue-responsive.css";
</style>